module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h5', [_c('b-badge', {
    attrs: {
      "variant": 'info'
    }
  }, [_vm._v("Assignment Timeline")])], 1), _vm._v(" "), (_vm.TM_AccordianButton) ? _c('b-button', {
    staticClass: "mt-1",
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "variant": "outline-info",
      "size": "xs"
    },
    on: {
      "click": function($event) {
        _vm.toggleActive()
      }
    }
  }, [_vm._v(_vm._s(_vm.TM_AccordianStatus ? "Hide Timeline" : "Show Timeline"))]) : _vm._e()], 1)]), _vm._v(" "), (_vm.allAssignmentTimelineSummaryData.length > 0 && _vm.TM_AccordianStatus) ? _c('div', {
    staticClass: "timeline"
  }, _vm._l((_vm.allAssignmentTimelineSummaryData), function(post, index) {
    return _c('div', {
      key: post.id,
      class: ['timeline-item', index % 2 === 0 ? 'left' : 'right']
    }, [_c('div', {
      staticClass: "timeline-panel"
    }, [_c('div', {
      staticClass: "timeline-heading"
    }, [_c('p', {
      staticClass: "text-muted"
    }, [_vm._v(_vm._s(_vm.formattedDate(post.assbill_log_createdAt)))])]), _vm._v(" "), _c('div', {
      staticClass: "timeline-body"
    }, [_c('p', [_vm._v(_vm._s(post.assbill_log_message))])])])])
  })) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-886d31b0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/common/assignmentTimeline.vue
// module id = 2793
// module chunks = 0